import { render, staticRenderFns } from "./rightsMg.vue?vue&type=template&id=43d93456&scoped=true&"
import script from "./rightsMg.vue?vue&type=script&lang=js&"
export * from "./rightsMg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d93456",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/yx-web-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43d93456')) {
      api.createRecord('43d93456', component.options)
    } else {
      api.reload('43d93456', component.options)
    }
    module.hot.accept("./rightsMg.vue?vue&type=template&id=43d93456&scoped=true&", function () {
      api.rerender('43d93456', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/rightsMg.vue"
export default component.exports